import "./components/app-root";
import "./components/install-prompt";
import "./components/map-view";
import "./components/onboarding-flow";
import { requestAllPermissions } from "./lib/permissions";

if ("serviceWorker" in navigator) {
	window.addEventListener("load", () => {
		navigator.serviceWorker
			.register(new URL("./sw.ts", import.meta.url), { type: "module" })
			.then((registration) => {
				console.log("ServiceWorker registered:", registration.scope);
			})
			.catch((error) => {
				console.error("ServiceWorker registration failed:", error);
			});
	});
}

window.addEventListener("load", () => {
	requestAllPermissions().then((result) => {
		console.log("Permissions:", result);
	});
});
